import React from 'react';

import ethImg from '../../assets/ethereum.png';

import './Asset.css';

function Asset(props) {
    return (
        <div className="ghost-asset-container">
            <div className="ghost-asset-list">
	        <div onClick={() => props.setAsset(props.assets[0][0])} className={props.asset !== props.assets[0][0] ? "ghost-asset-list-cell" : "ghost-asset-list-cell-active"}>
 		    <img src={ethImg} alt="maker dao"></img>
	    	    <span className="ghost-asset-list-cell-ticker">{props.assets[0][0]}</span>
	            <span className="ghost-asset-list-cell-name">{props.assets[0][1]}</span>
	        </div>
	        <div onClick={() => props.setAsset(props.assets[1][0])} className={props.asset !== props.assets[1][0] ? "ghost-asset-list-cell" : "ghost-asset-list-cell-active"}>
 		    <img src={ethImg} alt="tether stable"></img>
	    	    <span className="ghost-asset-list-cell-ticker">{props.assets[1][0]}</span>
	            <span className="ghost-asset-list-cell-name">{props.assets[1][1]}</span>
	        </div>
	        <div onClick={() => props.setAsset(props.assets[2][0])} className={props.asset !== props.assets[2][0] ? "ghost-asset-list-cell" : "ghost-asset-list-cell-active"}>
 		    <img src={ethImg} alt="ghost token"></img>
	    	    <span className="ghost-asset-list-cell-ticker">{props.assets[2][0]}</span>
	            <span className="ghost-asset-list-cell-name">{props.assets[2][1]}</span>
	        </div>
	    </div>

	    <div className="ghost-asset-buttons">
	        <div onClick={() => props.setStep(props.step-1)} className="ghost-asset-buttons-button">Previous Step</div>
	        <div onClick={() => props.setStep(props.step+1)} className="ghost-asset-buttons-button">Next Step</div>
	    </div>

        </div>
    )
}

export default Asset;
